var map = {
	"./template.bet575": 1517,
	"./template.bet575.tsx": 1517,
	"./template.bet777": 1519,
	"./template.bet777.tsx": 1519,
	"./template.betblast": 1520,
	"./template.betblast.tsx": 1520,
	"./template.betgalaxy": 1521,
	"./template.betgalaxy.tsx": 1521,
	"./template.betprofessor": 1522,
	"./template.betprofessor.tsx": 1522,
	"./template.betroyale": 1523,
	"./template.betroyale.tsx": 1523,
	"./template.betstride": 1524,
	"./template.betstride.tsx": 1524,
	"./template.buffalobet": 1525,
	"./template.buffalobet.tsx": 1525,
	"./template.chromabet": 1526,
	"./template.chromabet.tsx": 1526,
	"./template.default": 714,
	"./template.default.tsx": 714,
	"./template.fiestabet": 1527,
	"./template.fiestabet.tsx": 1527,
	"./template.forsport": 1528,
	"./template.forsport.tsx": 1528,
	"./template.gigabet": 1529,
	"./template.gigabet.tsx": 1529,
	"./template.goldenbet888": 2053,
	"./template.goldenbet888.tsx": 2053,
	"./template.goldenrush": 1530,
	"./template.goldenrush.tsx": 1530,
	"./template.hyperbet": 1531,
	"./template.hyperbet.tsx": 1531,
	"./template.juicybet": 1532,
	"./template.juicybet.tsx": 1532,
	"./template.junglebet": 1533,
	"./template.junglebet.tsx": 1533,
	"./template.magnumbet": 1534,
	"./template.magnumbet.tsx": 1534,
	"./template.oldgill": 1535,
	"./template.oldgill.tsx": 1535,
	"./template.puntcity": 1536,
	"./template.puntcity.tsx": 1536,
	"./template.puntgenie": 1537,
	"./template.puntgenie.tsx": 1537,
	"./template.pyramidbet": 1538,
	"./template.pyramidbet.tsx": 1538,
	"./template.questbet": 1539,
	"./template.questbet.tsx": 1539,
	"./template.slambet": 1540,
	"./template.slambet.tsx": 1540,
	"./template.sterlingparker": 1541,
	"./template.sterlingparker.tsx": 1541,
	"./template.sugarcastle": 1542,
	"./template.sugarcastle.tsx": 1542,
	"./template.templebet": 1543,
	"./template.templebet.tsx": 1543,
	"./template.titanbet": 1544,
	"./template.titanbet.tsx": 1544,
	"./template.ts": 976,
	"./template.vikingbet": 1545,
	"./template.vikingbet.tsx": 1545,
	"./template.volcanobet": 1546,
	"./template.volcanobet.tsx": 1546,
	"./template.wellbet": 1547,
	"./template.wellbet.tsx": 1547
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2436;